import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Voucher } from "@modules/vouchers/types";

export function useVoucherList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createVoucherModalRef = useRef<ModalRef>(null);
  const editVoucherModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Voucher>({
    resource: "v1/voucher_batch_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,
    createVoucherModalRef,
    editVoucherModalRef,
    refetch,
    setSelectedRows,
    translate,
  };
}
